import { cn } from "@/src/lib/utils";
import { ChevronLeft, ChevronLeftIcon } from "lucide-react";
import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function Content({
  title,
  children,
  contentAction,
  backButton, // TODO:
  preserveQuery = false,
}: {
  title?: string;
  children?: ReactNode;
  contentAction?: ReactNode;
  backButton?: boolean;
  preserveQuery?: boolean;
}) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const isRoot = pathname === "/";

  return (
    <div className="w-screen overflow-y-scroll sm:w-full h-full pt-12 pb-10 px-6">
      <div className="flex justify-between items-center mb-6 max-w-full flex-wrap">
        <h1
          className={cn(
            "text-3xl font-semibold mb-1 flex gap-1 items-center",
            !isRoot && "hover:underline cursor-pointer",
          )}
          onClick={() => {
            if (!isRoot) {
              const path = pathname.split("/");
              path.pop();
              const newPath = path.join("/") || "/";

              navigate(preserveQuery ? `${newPath}${search}` : newPath);
            }
          }}
        >
          {!isRoot && <ChevronLeftIcon size={24} />}
          {title}
        </h1>
        {contentAction}
      </div>
      {children}
    </div>
  );
}
